export const zoomScale = 0.25;
export const SELECTED_CLASS = "selected";

// export const CONTENTS_ENDPOINT = "https://contents.makmate.com";
// export const REGION = "GB"; // userInforepair country commonPrivader
// export const LOCALE = "en-US"; // login
// export const MODEL = "VC1310L";
export const layerList = ["layer1", "layer2"];
